const USER_CONFIG_KEY = 'user_config';

export interface UserConfig {
    leftMenuOpen?: boolean;
    serviceCategories?: Array<{ value: string; label: string }>;
    serviceTableView?: 'table' | 'list';
}

export const getUserConfig = (): UserConfig => {
    try {
        const stored = localStorage.getItem(USER_CONFIG_KEY);
        return stored ? JSON.parse(stored) : {};
    } catch (error) {
        console.error('Error parsing user config:', error);
        return {};
    }
};

export const updateUserConfig = (updates: Partial<UserConfig>): void => {
    const current = getUserConfig();
    const updated = { ...current, ...updates };
    localStorage.setItem(USER_CONFIG_KEY, JSON.stringify(updated));
};

export const getLeftMenuState = (): boolean => {
    const config = getUserConfig();
    return config.leftMenuOpen ?? true;
};

export const setLeftMenuState = (isOpen: boolean): void => {
    updateUserConfig({ leftMenuOpen: isOpen });
};

export const getServiceCategories = (): Array<{ value: string; label: string }> | undefined => {
    const config = getUserConfig();
    return config.serviceCategories;
};

export const setServiceCategories = (categories: Array<{ value: string; label: string }>): void => {
    updateUserConfig({ serviceCategories: categories });
};

export const getServiceTableView = (): 'table' | 'list' | undefined => {
    const config = getUserConfig();
    return config.serviceTableView;
};

export const setServiceTableView = (view: 'table' | 'list'): void => {
    updateUserConfig({ serviceTableView: view });
};
